import { ListeTable } from '@mairistem/liste';

type ArreteAnnuelListeTableHeaderProps = {
  [key: string]: any;
};

const ArreteAnnuelListeTableHeader = (props: ArreteAnnuelListeTableHeaderProps) => {
  const { ...rest } = props;

  return (
    <>
      <ListeTable.Column {...rest} name="libelle" verticalAlign="middle">
        Libellé
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="date" style={{ width: 160 }} verticalAlign="middle">
        Date d&apos;arrêté
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="regisseur" style={{ width: 250 }} verticalAlign="middle">
        Régisseur
      </ListeTable.Column>
      <ListeTable.Column
        {...rest}
        name="montantTotal"
        style={{ width: 180 }}
        verticalAlign="middle"
      >
        Montant
      </ListeTable.Column>
    </>
  );
};

export default ArreteAnnuelListeTableHeader;
